<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Submission Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading :title="`Update ${submission.publicNumber()}`" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="['edit submission']">
      <template #gated-content>
        <submission-card v-if="submission" :submission="submission" />

        <SubmissionApplyTestPackageForm :submission="submission" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { notificationOptions } from '@/shared/toast-notification-options'
import { getModel } from '@/shared/fetch-utils'
import { submissionNotifications } from '@/shared/notifications'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'
import PermissionAlertGate from '@/components/permission/PermissionAlertGate'
import SubmissionApplyTestPackageForm from '@/components/lab/submission/SubmissionApplyTestPackageForm'
import TestPackageModel from '@/models/lab/TestPackageModel'
import SubmissionCard from '@/components/lab/submission/SubmissionCard'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'SubmissionApplyTestPackage',
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SubmissionApplyTestPackageForm,
    SubmissionCard
  },
  data () {
    return {
      loading: true,
      submission_id: this.$route.params.submission_id || null,
      submission: null
    }
  },
  computed: {
    button_config () {
      return {
        buttons: [
          {
            icon: "fa-eye",
            linkto: `/submissions/${this.submission_id}`,
            title: "View sample",
            variant: "info",
          },
        ]
      }
    },
  },
  async mounted () {
    this.loading = true

    this.submission = await getModel({
      model_type: 'submission',
      id: this.submission_id,
      message: this.$bvToast
    })

    this.loading = false
  },
  methods: {
    async submit (form_data) {
      try {
        const test_package_model = new TestPackageModel({ id: form_data.selected_test_package })

        await test_package_model.apply({
          submissions: [this.submission.id],
        })


        this.editSuccess()
        this.$router.push(`/submissions/${this.submission_id}`)
      } catch ({ response }) {
        const { status, data } = response.response;

        this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
          title: "Server Error.",
          variant: "danger",
        })
      }
    }
  },
  notifications: submissionNotifications
}
</script>
